/**
 * Konaklama vergisi orani.
 *
 * Oran SABIT DEGILDIR: Cumhurbaskani karariyla degisir ve gecmise donuk
 * olarak da onemlidir - Mart 2026'da kesilmis bir faturanin yeniden
 * basilmasi gerektiginde O GUNUN orani gecerlidir. Bu yuzden tek bir sabit
 * yerine TARIHLI bir cizelge tutuyoruz ve oran hizmet tarihinden secilir.
 *
 * Cizelge (6802 sayili Gider Vergileri Kanunu md. 34):
 *   2023-01-01 → %2   Verginin yururluge girisi
 *   2026-05-01 → %1   Cumhurbaskani Karari 11263 (RG 1.5.2026 / 33240).
 *                     Karar metni "31/12/2026 tarihine kadar (bu tarih dahil)"
 *                     der; uzatilmazsa 2027 basinda %2'ye doner.
 *   2027-01-01 → %2   Yukaridaki kararin kendi son kullanma tarihi.
 *
 * DIKKAT: 2027-01-01 satiri bir TAHMIN degil, yururlukteki kararin kendi
 * sinirini yansitir. Oran uzatilir ya da degistirilirse BURASI guncellenmeli.
 */

export interface VergiDilimi {
  /** Bu oranin gecerli oldugu ilk gun (ISO, dahil). */
  baslangic: string;
  oran: number;
}

export const KONAKLAMA_VERGISI_CIZELGESI: VergiDilimi[] = [
  { baslangic: '2023-01-01', oran: 0.02 },
  { baslangic: '2026-05-01', oran: 0.01 },
  { baslangic: '2027-01-01', oran: 0.02 },
];

/**
 * Verilen gun icin gecerli konaklama vergisi orani.
 *
 * @param gun ISO tarih (YYYY-AA-GG). Konaklamanin/hizmetin tarihi.
 */
export function konaklamaVergisiOrani(gun: string): number {
  let oran = 0;
  for (const dilim of KONAKLAMA_VERGISI_CIZELGESI) {
    if (gun >= dilim.baslangic) oran = dilim.oran;
    else break;
  }
  return oran;
}

/** Matrah (KDV haric hizmet bedeli) uzerinden vergi tutari - kurus. */
export function konaklamaVergisiKurus(matrahKurus: number, gun: string): number {
  return Math.round(matrahKurus * konaklamaVergisiOrani(gun));
}
